import { ADD_NOTIFICATION, REMOVE_NOTIFICATION, REMOVE_NOTIFICATION_BY_TYPE } from './types';

export const addNotification = (payload) => ({ type: ADD_NOTIFICATION, payload });

export const removeNotification = (id) => ({ type: REMOVE_NOTIFICATION, payload: { id } });

// eslint-disable-next-line max-len
export const removeNotificationByType = (type) => ({ type: REMOVE_NOTIFICATION_BY_TYPE, payload: { type } });
